import { useState, useEffect } from 'react';
import AdminLayout from '../../components/layout/AdminLayout';
import { Button } from '../../components/ui/button';
import { Label } from '../../components/ui/label';
import { LangTabs } from '../../components/ui/lang-tabs';
import { toast } from 'sonner';
import { PanelBottom, Save } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function AdminFooterPage() {
  const { t } = useLanguage();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ text: '', text_pt: '', text_en: '' });
  const [lang, setLang] = useState('ja');

  const textKey = lang === 'ja' ? 'text' : `text_${lang}`;

  useEffect(() => {
    axios.get(`${API_URL}/api/admin/settings/footer`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    }).then(res => {
      const { key, updated_at, updated_by, ...data } = res.data;
      setForm(prev => ({ ...prev, ...data }));
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const handleSave = async () => {
    setSaving(true);
    try {
      await axios.put(`${API_URL}/api/admin/settings/footer`, form, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' }
      });
      toast.success(t('footer_saved'));
    } catch (error) {
      toast.error(t('content_save_failed'));
    } finally { setSaving(false); }
  };

  if (loading) return <AdminLayout><div className="text-center py-12 text-muted-foreground">{t('loading')}</div></AdminLayout>;

  return (
    <AdminLayout>
      <div data-testid="admin-footer-page">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="font-heading text-3xl font-bold text-primary flex items-center gap-3">
              <PanelBottom className="h-8 w-8" />
              {t('footer_admin_title')}
            </h1>
            <p className="text-muted-foreground mt-1">{t('footer_admin_subtitle')}</p>
          </div>
          <LangTabs activeLang={lang} onChange={setLang} />
        </div>
        <div className="bg-card border border-border/50 rounded-2xl p-6 space-y-6">
          <div className="space-y-2">
            <Label>{t('footer_text_label')}{lang !== 'ja' && <span className="text-xs text-muted-foreground ml-2">({lang.toUpperCase()})</span>}</Label>
            <textarea
              value={form[textKey] || ''}
              onChange={(e) => setForm({ ...form, [textKey]: e.target.value })}
              rows={4}
              className="w-full rounded-lg border border-border bg-background px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-accent/30"
              placeholder="© 2026 PRC Remit. All rights reserved. 資金移動業者 登録番号: XX-XXXXX"
              data-testid="footer-text-input"
            />
            <p className="text-xs text-muted-foreground">{t('footer_text_hint')}</p>
          </div>

          <div className="bg-secondary/30 rounded-xl p-6">
            <Label className="text-xs text-muted-foreground mb-2 block">{t('footer_preview')}</Label>
            <div className="text-sm text-muted-foreground text-center whitespace-pre-wrap">
              {form[textKey] || '© 2026 PRC Remit. All rights reserved.'}
            </div>
          </div>

          <Button onClick={handleSave} disabled={saving} className="gap-2" data-testid="save-footer-btn">
            <Save className="h-4 w-4" />{saving ? t('admin_settings_saving') : t('footer_save_btn')}
          </Button>
        </div>
      </div>
    </AdminLayout>
  );
}
